import { render } from "./quick-add-drawer-trigger.vue?vue&type=template&id=0604d93b"
import script from "./quick-add-drawer-trigger.vue?vue&type=script&lang=js"
export * from "./quick-add-drawer-trigger.vue?vue&type=script&lang=js"

import "./quick-add-drawer-trigger.vue?vue&type=style&index=0&id=0604d93b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__